import { employeeContractsToListMap, multipleEmployeesContractsToListMap, parseContract } from 'src/helpers/modular/employeesContractsUtil';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import Utils from 'src/utils';
import { wtsApi } from 'src/api';
export var EmployeeContractsActions;
(function (EmployeeContractsActions) {
    EmployeeContractsActions["LOADING_ALL_EMPLOYEES_CONTRACTS"] = "LOADING_ALL_EMPLOYEES_CONTRACTS";
    EmployeeContractsActions["SAVE_ALL_EMPLOYEES_CONTRACTS"] = "SAVE_ALL_EMPLOYEES_CONTRACTS";
    EmployeeContractsActions["ERROR_LOADING_ALL_EMPLOYEES_CONTRACTS"] = "ERROR_LOADING_ALL_EMPLOYEES_CONTRACTS";
    EmployeeContractsActions["LOADING_EMPLOYEE_CONTRACTS"] = "LOADING_EMPLOYEE_CONTRACTS";
    EmployeeContractsActions["SAVE_EMPLOYEE_CONTRACTS"] = "SAVE_EMPLOYEE_CONTRACTS";
    EmployeeContractsActions["UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS"] = "UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS";
    EmployeeContractsActions["SUCCESS_UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS"] = "SUCCESS_UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS";
    EmployeeContractsActions["ERROR_UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS"] = "ERROR_UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS";
    EmployeeContractsActions["SAVE_NEW_EMPLOYEE_CONTRACT"] = "SAVE_NEW_EMPLOYEE_CONTRACT";
    EmployeeContractsActions["UPDATE_EMPLOYEE_CONTRACT"] = "UPDATE_EMPLOYEE_CONTRACT";
})(EmployeeContractsActions || (EmployeeContractsActions = {}));
export const loadingAllEmployeesContracts = () => ({
    type: EmployeeContractsActions.LOADING_ALL_EMPLOYEES_CONTRACTS
});
export const successLoadingAllEmployeesContracts = (list, allContracts) => ({
    type: EmployeeContractsActions.SAVE_ALL_EMPLOYEES_CONTRACTS,
    payload: { list, allContracts }
});
export const errorLoadingAllEmployeesContracts = () => ({
    type: EmployeeContractsActions.ERROR_LOADING_ALL_EMPLOYEES_CONTRACTS
});
export const loadingEmployeeContracts = () => ({
    type: EmployeeContractsActions.LOADING_EMPLOYEE_CONTRACTS
});
export const successLoadingEmployeeContracts = (userId, list) => ({
    type: EmployeeContractsActions.SAVE_EMPLOYEE_CONTRACTS,
    payload: { userId, list }
});
export const updatingMultipleEmployeeContracts = () => ({
    type: EmployeeContractsActions.UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS
});
export const successUpdatingMultipleEmployeeContracts = () => ({
    type: EmployeeContractsActions.SUCCESS_UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS
});
export const errorUpdatingMultipleEmployeeContracts = () => ({
    type: EmployeeContractsActions.ERROR_UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS
});
export const saveNewEmployeeContract = (raw, decapitalized) => ({
    type: EmployeeContractsActions.SAVE_NEW_EMPLOYEE_CONTRACT,
    payload: { raw, decapitalized }
});
export const updateEmployeeContract = (raw, decapitalized) => ({
    type: EmployeeContractsActions.UPDATE_EMPLOYEE_CONTRACT,
    payload: { raw, decapitalized }
});
export function requestAllEmployeesContracts() {
    // @ts-ignore
    return (dispatch) => {
        dispatch(loadingAllEmployeesContracts());
        return wtsApi.userContracts.userContractsList({ userIds: '' })
            .then(({ data }) => data.Data)
            .then((allContracts) => {
            const list = multipleEmployeesContractsToListMap(allContracts);
            dispatch(successLoadingAllEmployeesContracts(list, allContracts));
            return allContracts;
        })
            .catch((error) => {
            dispatch(errorLoadingAllEmployeesContracts());
            toastrError(error);
        });
    };
}
export function requestEmployeeContracts({ userId, ...other }) {
    // @ts-ignore
    return (dispatch) => {
        dispatch(loadingEmployeeContracts());
        return wtsApi.userContracts.userContractsList({ userIds: userId, ...other })
            .then(({ data }) => data.Data)
            .then((allContracts) => {
            const list = employeeContractsToListMap(allContracts);
            dispatch(successLoadingEmployeeContracts(userId, list));
            return allContracts;
        })
            .catch((error) => {
            toastrError(error);
        });
    };
}
export function requestEmployeeContractUpdateMultiple(data) {
    return (dispatch) => {
        dispatch(updatingMultipleEmployeeContracts());
        return wtsApi.userContracts.multipleUpdate(data)
            .then((response) => response.data)
            .then(async (response) => {
            await dispatch(requestAllEmployeesContracts());
            toastrSuccess(response);
            dispatch(successUpdatingMultipleEmployeeContracts());
        })
            .catch((error) => {
            toastrError(error);
            dispatch(errorUpdatingMultipleEmployeeContracts());
        });
    };
}
export function createEmployeeContractWithRows(payload) {
    // @ts-ignore
    return (dispatch) => {
        return wtsApi.userContracts.withRowsCreate(payload)
            .then((response) => {
            const contract = response.data.Data;
            const decapitalized = parseContract(Utils.objects.decapitalizeObjectKeysRecursively(contract));
            dispatch(saveNewEmployeeContract(contract, decapitalized));
            toastrSuccess(response);
            return contract;
        })
            .catch((error) => {
            toastrError(error);
            return Promise.reject();
        });
    };
}
export function updateEmployeeContractWithRows(contractId, payload) {
    // @ts-ignore
    return (dispatch) => {
        return wtsApi.userContracts.withRowsUpdate(contractId, payload)
            .then((response) => {
            const contract = response.data.Data;
            const decapitalized = parseContract(Utils.objects.decapitalizeObjectKeysRecursively(contract));
            dispatch(updateEmployeeContract(contract, decapitalized));
            toastrSuccess(response);
            return contract;
        })
            .catch((error) => {
            toastrError(error);
            return Promise.reject();
        });
    };
}
